import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  WidthMode,
  DrawerMenuItem,
} from "../services/types/ComponentTypes";

// Using public folder paths for images so they're accessible in the UI
const homeIcon = "/images/icons/home-icon (2).webp";
const garageIcon = "/images/icons/Garage_operations.png";
const vehicleIcon = "/images/icons/vehicle.webp";
const inspectionIcon = "/images/icons/Garage_operations.png";
const jobCardIcon = "/images/icons/job_card.webp";
const inventoryIcon = "/images/icons/masters.png";
const employeeIcon = "/images/icons/manpower.webp";
const hrmsIcon = "/images/icons/hrms.png";
const salesIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>`; // Shopping cart for sales
const customersIcon = "/images/icons/Customer.webp";
const invoicesIcon = "/images/icons/invoice.png";
const salesReturnVouchersIcon = "/images/icons/sales-return-voucher.png";
const purchaseReturnVouchersIcon = "/images/icons/sales-return-voucher.png"; // Using same icon for now
const purchaseIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>`;
const employeeGroupIcon = "/images/icons/Employee group.webp";
const productsIcon = "/images/icons/item master.webp";
const labourOthersIcon = "/images/icons/labour.png";
const stockIcon = "/images/icons/Stock.png";
const partsIssueIcon = "/images/icons/Parts issue.png";
const partsReturnIcon = "/images/icons/Parts return.png";
const partsRequestIcon = "/images/icons/Parts issue.png";
const employeesIcon = "/images/icons/manpower.webp";
const mastersIcon = "/images/icons/masters.png";
const branchIcon = "/images/icons/branch.png";

const reportIcon = jobCardIcon;
const toolsIcon = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>`;

export const screen_100_home: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    drawerMenuEnabled: true,
    drawerMenu: {
      backgroundColor: "#1f2937",
      contentTextColor: "#ffffff",
      menu: [
        {
          title: "Home",
          screenId: "home",
          iconPath: homeIcon,
        },
        {
          title: "Garage",
          moduleId: "1",
          backgroundColor: "var(--primary-black)",
          contentTextColor: "#ffffff",
          iconPath: garageIcon, // Placeholder emoji icon
          submenu: {
            title: "Garage operations",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Vehicles",
                screenId: "101",
                iconPath: vehicleIcon, // Placeholder emoji icon
              },
              {
                title: "Inspection",
                screenId: "103",
                iconPath: inspectionIcon, // Placeholder emoji icon
              },
              {
                title: "Job Card",
                screenId: "104",
                iconPath: jobCardIcon, // Placeholder emoji icon
              },
              {
                title: "JC invoice auth. request",
                screenId: "184",
                iconPath: jobCardIcon,
              },
              {
                title: "JC invoice auth. approve",
                screenId: "185",
                iconPath: jobCardIcon,
              },
              // {
              //   title: "Close job card",
              //   screenId: "39",
              //   iconPath: jobCardIcon, // Using job card icon for close job card
              // },
            ],
          },
        },
        {
          title: "Inventory",
          screenId: "screen2",
          moduleId: "2",
          iconPath: inventoryIcon, // Placeholder emoji icon
          submenu: {
            title: "Inventory management",
            mode: "inline", // Changed to "outside" to demonstrate popup menu
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Products",
                screenId: "105",
                iconPath: productsIcon, // Placeholder emoji icon
              },
              {
                title: "Labour and Other",
                screenId: "111",
                iconPath: labourOthersIcon, // Placeholder emoji icon
              },
              {
                title: "Stock Balance",
                screenId: "112",
                iconPath: stockIcon, // Placeholder emoji icon
              },
              {
                title: "Stock correction",
                screenId: "181",
                iconPath: stockIcon,
              },
              {
                title: "Stock movement",
                screenId: "171",
                iconPath: stockIcon,
              },
              {
                title: "Batch",
                screenId: "172",
                iconPath: stockIcon,
              },
              {
                title: "Parts request",
                screenId: "109",
                iconPath: partsRequestIcon,
              },
              {
                title: "Parts issue",
                screenId: "113",
                iconPath: partsIssueIcon, // Placeholder emoji icon
              },
              {
                title: "Parts return",
                screenId: "115",
                iconPath: partsReturnIcon, // Placeholder emoji icon
              },
            ],
          },
        },
        {
          title: "Sales",
          moduleId: "3",
          iconPath: salesIcon, // Placeholder emoji icon
          submenu: {
            title: "",
            mode: "inline", // Changed to "outside" to demonstrate popup menu
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Customers",
                screenId: "114",
                iconPath: customersIcon, // Placeholder emoji icon
              },
              {
                title: "Invoice",
                screenId: "117",
                iconPath: invoicesIcon, // Placeholder emoji icon
              },
              {
                title: "Sales return vouchers",
                screenId: "118",
                iconPath: salesReturnVouchersIcon, // Placeholder emoji icon
              },
              {
                title: "Proforma Invoice",
                screenId: "174",
                iconPath: invoicesIcon,
              },
              {
                title: "Consolidated Invoice",
                screenId: "2236",
                iconPath: invoicesIcon,
              },
            ],
          },
        },
        {
          title: "Purchases",
          moduleId: "4",
          iconPath: purchaseIcon, // Shopping bag icon for purchases
          submenu: {
            title: "",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Vendors",
                screenId: "127",
                iconPath: customersIcon, // Using customers icon as placeholder for vendors
              },
              {
                title: "Purchase order",
                screenId: "129",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Purchase",
                screenId: "138",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Purchase return vouchers",
                screenId: "125",
                iconPath: purchaseReturnVouchersIcon,
              },
            ],
          },
        },
        {
          title: "Accounts",
          moduleId: "7",
          iconPath: invoicesIcon, // Using invoices icon as placeholder
          submenu: {
            title: "",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Cash and bank",
                screenId: "131",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Charts of accounts",
                screenId: "132",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Account master",
                screenId: "183",
                iconPath: invoicesIcon,
              },
              {
                title: "Account heads",
                screenId: "134",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Subgroup",
                screenId: "136",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              // {
              //   title: "Account flow",
              //   screenId: "24",
              //   iconPath: invoicesIcon, // Using invoices icon as placeholder
              // },
              {
                title: "Accounting years",
                screenId: "27",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              // {
              //   title: "Ledger carry forward",
              //   screenId: "34",
              //   iconPath: invoicesIcon, // Using invoices icon as placeholder
              // },

            ],
          },
        },
        {
          title: "Vouchers",
          moduleId: "7",
          iconPath: invoicesIcon, // Using invoices icon as placeholder
          submenu: {
            title: "",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Manual journals",
                screenId: "146",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              // {
              //   title: "VAT Journal",
              //   screenId: "177",
              //   iconPath: invoicesIcon,
              // },
              {
                title: "Contra vouchers",
                screenId: "147",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Petty cash vouchers",
                screenId: "148",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Cash payment vouchers",
                screenId: "149",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Bank payment vouchers",
                screenId: "161",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Credit notes",
                screenId: "163",
                iconPath: invoicesIcon,
              },
              {
                title: "Debit notes",
                screenId: "164",
                iconPath: invoicesIcon,
              },
              {
                title: "Receipt vouchers",
                screenId: "30",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
              {
                title: "Payment vouchers",
                screenId: "143",
                iconPath: invoicesIcon, // Using invoices icon as placeholder
              },
            ],
          },
        },
        {
          title: "Tools",
          moduleId: "8",
          iconPath: toolsIcon,
          submenu: {
            title: "Tools",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "PDC reminder",
                screenId: "179",
                iconPath: invoicesIcon,
              },
              {
                title: "Bank reconciliation",
                screenId: "191",
                iconPath: invoicesIcon,
              },
              {
                title: "Receipt summary",
                screenId: "142",
                iconPath: invoicesIcon,
              },
              {
                title: "Payments summary",
                screenId: "145",
                iconPath: invoicesIcon,
              },
              {
                title: "Bill allocation",
                screenId: "196",
                iconPath: invoicesIcon,
              },
              {
                title: "Bill release",
                screenId: "197",
                iconPath: invoicesIcon,
              },
            ],
          },
        },
        {
          title: "Employee",
          iconPath: employeeIcon, // Placeholder emoji icon
          moduleId: "5",
          submenu: {
            title: "Inventory management",
            mode: "inline", // Changed to "outside" to demonstrate popup menu
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Employees",
                screenId: "108",
                iconPath: employeeIcon, // Placeholder emoji icon
              },
              {
                title: "Employee Group",
                screenId: "110",
                iconPath: employeeGroupIcon, // Placeholder emoji icon
              },
              {
                title: "Sales Agent",
                screenId: "168",
                iconPath: customersIcon, // Using customers icon as placeholder
              },
              {
                title: "Users",
                screenId: "169",
                iconPath: employeesIcon,
              },
            ],
          },
        },
        // HRMS Module - Only in Development 
      ...(false ? [{
          title: "HRMS",
          iconPath: hrmsIcon,
          moduleId: "10",
          submenu: {
            title: "HR Operations",
            mode: "inline",
            backgroundColor: "#1D4ED8",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Employees",
                screenId: "2203",
                iconPath: "👔",
              },
              {
                title: "Employee Groups",
                screenId: "2206",
                iconPath: "🧑‍🤝‍🧑",
              },
              // {
              //   title: "Organization",
              //   screenId: "hrm/organization",
              //   iconPath: "🏢",
              // },
              {
                title: "Attendance",
                screenId: "2200",
                iconPath: "🕒",
              },
              {
                title: "Leave Management",
                screenId: "2201",
                iconPath: "🌴",
              },
              {
                title: "Time Shift",
                screenId: "2226",
                iconPath: "⏰",
              },
              {
                title: "View Holidays",
                screenId: "2235",
                iconPath: "🗓️",
              },
              {
                title: "Setup Holiday Calendar",
                screenId: "2218",
                iconPath: "🗓️",
              },
              {
                title: "Payroll",
                screenId: "2231",
                iconPath: "💳",
              },
              // {
              //   title: "Performance",
              //   screenId: "hrm/performance",
              //   iconPath: "📈",
              // },
              // {
              //   title: "Report",
              //   screenId: "hrm/reports",
              //   iconPath: "📝",
              // },
              {
                title: "Profile",
                screenId: "2217",
                iconPath: "👤",
              },
            ],
          },
        }] as DrawerMenuItem[] : []),
        {
          title: "Masters",
          iconPath: mastersIcon,
          moduleId: "6",
          submenu: {
            title: "Masters",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [

              {
                title: "Vehicle make",
                screenId: "151/6",
                iconPath: vehicleIcon,
              },
              {
                title: "Vehicle type",
                screenId: "152/9d8f93e4-173c-422a-9884-44c600c58e50_000001",
                iconPath: vehicleIcon,
              },
              {
                title: "Lookups",
                screenId: "153",
                iconPath: productsIcon,
              },
              // {
              //   title: "Branches",
              //   screenId: "154",
              //   iconPath: branchIcon,
              // },
            ],
          },
        },
        {
          title: "Reports",
          iconPath: reportIcon,
          moduleId: "9",
          submenu: {
            title: "",
            mode: "inline",
            backgroundColor: "#388E3C",
            contentTextColor: "#ffffff",
            items: [
              {
                title: "Reports",
                screenId: "155",
                iconPath: reportIcon,
              },
            ],
          },
        },
      ],
    },
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          widthMode: WidthMode.FULL,
          direction: "column" as any,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GRID,
            columnNumber: "m2 t2 w4",
            style: {
              backgroundColor: "#ffffff",
            },
            childComponents: [
              {
                componentType: ComponentType.INFO_CARD,
                name: "Employees",
                value: 8,
                style: {
                  backgroundColor: "#5ccb59",
                  textColor: "#ffffff",
                },
              },
              {
                componentType: ComponentType.INFO_CARD,
                name: "Customers",
                value: 11,
                style: {
                  backgroundColor: "var(--primary-black)",
                  textColor: "#ffffff",
                },
              },
              {
                componentType: ComponentType.INFO_CARD,
                name: "Vendors",
                value: 7,
                style: {
                  backgroundColor: "#848484",
                  textColor: "#ffffff",
                },
              },
              {
                componentType: ComponentType.INFO_CARD,
                name: "Products",
                value: 42,
                style: {
                  backgroundColor: "#2aa84c",
                  textColor: "#ffffff",
                },
              },
            ],
          },
          {
            componentType: ComponentType.WEB_VIEW,
            reportUrl: "pabreport/report?name=dash_board",
            reportName: "dash_board",
            style: {
              backgroundColor: "#ffffff",
            },
          },
        ],
      },
    ],
  },
];
